import React from "react";
import { Navigate, Route, Routes } from "react-router-dom-v5-compat";
import { useRegion } from "apps/web/src/hooks/useRegion";
import { RoleRoute } from "../../ProtectedRoutes";
import { SecondaryNavLayout, SecondaryNavLayoutProps } from "../../SecondaryNav/SecondaryNavLayout";
import { BulkAssignTemplatePage } from "./BulkAssignTemplatePage";
import { ExchangeSetsPage } from "./ExchangeSetsPage";
import { MealPlanTemplatesPage } from "./MealPlanTemplatesPage";
import { NAV_MEAL_PLANS_EXCHANGE_SETS, NAV_MEAL_PLAN_TEMPLATES, NAV_MEAL_PLAN_ASSIGN_TEMPLATE, mealPlansLink } from "./MealPlansPaths";

export const MealPlansRouter = () => {
  const { isApacRegion } = useRegion();

  const secondaryNavLayoutProps: SecondaryNavLayoutProps = {
    current: mealPlansLink,
    enableAthleteSearch: true,
    tabs: [
      {
        name: "Meal Plan Templates",
        to: NAV_MEAL_PLAN_TEMPLATES,
      },
      ...(isApacRegion
        ? []
        : [
            {
              name: "Exchange Sets",
              to: NAV_MEAL_PLANS_EXCHANGE_SETS,
            },
          ]),
    ],
  };

  return (
  <Routes>
    <Route element={<SecondaryNavLayout {...secondaryNavLayoutProps} />}>
      <Route element={<RoleRoute roles={["dietitian"]} />}>
        <Route index element={<MealPlanTemplatesPage />} />
        <Route path={NAV_MEAL_PLAN_TEMPLATES} element={<MealPlanTemplatesPage />} />
        <Route
          path={NAV_MEAL_PLANS_EXCHANGE_SETS}
          element={isApacRegion ? <Navigate to={NAV_MEAL_PLAN_TEMPLATES} replace /> : <ExchangeSetsPage />}
        />
      </Route>
    </Route>
    <Route element={<RoleRoute roles={["dietitian"]} />}>
      <Route path={NAV_MEAL_PLAN_ASSIGN_TEMPLATE} element={<BulkAssignTemplatePage />} />
    </Route>
  </Routes>
  );
};
